"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _recompose = require("recompose");
var _reactIntl = require("react-intl");
var _excluded = ["classes", "className", "disabled", "inputClassName", "inputRef", "intl", "placeholder", "readOnly", "theme", "title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type ElementRef } from 'react';*/ /*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  var INPUT_PLACEHOLDER_VALUE = _objectSpread(_objectSpread({}, theme.typography.extraSmallText), {}, {
    color: theme.colors.ashGrey,
    cursor: 'text'
  });
  return {
    root: {
      position: 'relative'
    },
    input: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, theme.mixins.inputStyle), theme.mixins.truncate), theme.typography.extraSmallText), {}, {
      paddingLeft: theme.variables.inputPadding,
      borderRadius: theme.variables.borderRadiusSmall,
      '&::placeholder': INPUT_PLACEHOLDER_VALUE,
      '&::-webkit-input-placeholder': INPUT_PLACEHOLDER_VALUE,
      '&:-ms-input-placeholder': INPUT_PLACEHOLDER_VALUE,
      '&::-ms-input-placeholder': INPUT_PLACEHOLDER_VALUE,
      '&::-moz-placeholder': INPUT_PLACEHOLDER_VALUE,
      '&:-moz-placeholder': INPUT_PLACEHOLDER_VALUE
    })
  };
};
/*:: export type SearchInputType = InjectSheetProvidedProps &
  HTMLInputElement & {
    inputClassName?: string,
    inputRef?: ElementRef<*>,
    intl: Object,
    placeholder: string
  };*/
var SearchInput = function SearchInput(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    disabled = _ref /*:: */.disabled,
    inputClassName = _ref /*:: */.inputClassName,
    ref = _ref /*:: */.inputRef,
    intl = _ref /*:: */.intl,
    placeholder = _ref /*:: */.placeholder,
    readOnly = _ref /*:: */.readOnly,
    theme = _ref /*:: */.theme,
    title = _ref /*:: */.title,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, className),
    title: title
  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.input, inputClassName),
    "data-testid": "search-input",
    disabled: disabled || readOnly,
    placeholder: placeholder
  }, _objectSpread({
    readOnly: readOnly,
    ref: ref
  }, props))));
};
SearchInput.displayName = 'SearchInput';
SearchInput.defaultProps = {
  autoComplete: 'off',
  disabled: false,
  readOnly: false,
  type: 'search'
};
var EnhancedSearchInput = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _injectSheet.default)(Style))(SearchInput);
EnhancedSearchInput.displayName = 'SearchInput';
var _default = exports.default = EnhancedSearchInput;
//# sourceMappingURL=SearchInput.js.map